import { apiInstance } from "../../services/api";

import Requirement from "../../domains/Requirement";

import { ENDPOINT } from "./config";
import { setItemInLocalStorage } from "../../config/localStorage";

export function fetchRequirements(
  queryParams = "",
): Promise<{ rows: Array<Requirement>; count: number }> {
  setItemInLocalStorage("queryParams", queryParams);
  return apiInstance
    .get<{ rows: Array<Requirement>; count: number }>(
      `${ENDPOINT}${queryParams}`,
    )
    .then(resp => resp.data)
    .catch(error => {
      return error;
    });
}
